import PrintManifestContainer from "../containers/PrintManifestContainer";

const PrintManifestPage = () => {
    return <PrintManifestContainer />;
};

export default PrintManifestPage;
